const theftsPerYearData = [
  {
    year: '2019', Bike: 94, 'E-scooter': 3, 'E-bike': 7,
  },
  {
    year: '2020', Bike: 45, 'E-scooter': 9, 'E-bike': 6,
  },
  {
    year: '2021', Bike: 81, 'E-scooter': 45, 'E-bike': 25,
  },
  {
    year: '2022', Bike: 157, 'E-scooter': 246, 'E-bike': 85,
  },
  {
    year: '2023', Bike: 64, 'E-scooter': 322, 'E-bike': 73,
  },
];

export default theftsPerYearData;
